import styled from "styled-components";

import { IllustrationContainerContainer } from "../../atoms/IllustrationContainer/styles";
import { NotificationContainerWrapper } from "../../atoms/NotificationContainer/styles";
import { NotificationTicketContainer } from "../../atoms/NotificationTicket/styles";
import { NotificationTitleContainer } from "../../atoms/NotificationTitle/styles";

export const TicketCreatedNotificationContainer = styled.div`
  ${IllustrationContainerContainer} {
    grid-row: 1 / 5;
  }

  a {
    width: fit-content;
  }

  #admin-console-notification-go-to-ticket {
    margin-bottom: 0.75rem;
    width: fit-content;
  }

  &.refund ${NotificationContainerWrapper} {
    background: linear-gradient(
      90deg,
      rgba(169, 99, 255, 0.12) 0%,
      rgba(32, 32, 32, 0.12) 100%
    );

    border-left: 2px solid #a963ff;
  }

  &.recurrency ${NotificationContainerWrapper} {
    background: linear-gradient(
      90deg,
      rgba(255, 100, 3, 0.12) 0%,
      rgba(32, 32, 32, 0.12) 100%
    );

    border-left: 2px solid #ff6403;
  }
`;

export const NotificationTicketGrid = styled.div`
  display: grid;

  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);

  align-items: center;

  gap: 0.25rem;

  & > :nth-of-type(even) {
    text-align: end;
    justify-content: flex-end;
  }

  & > ${NotificationTitleContainer} {
    font: 500 0.75rem/150% "Inter";
    letter-spacing: 0;
    vertical-align: middle;
  }

  & > :last-child {
    font: 500 0.813rem/150% "Inter";
  }

  ${NotificationTicketContainer} {
    margin-top: 0;
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
`;
